import type { ValidationRules } from "../forms";

/**
 * Field-level constraints for audit findings (US-082).
 *
 * The finding routes were previously BARE (ad-hoc presence checks only) —
 * these bounds are new policy, written to the handler-read body shapes and
 * sized to house style (titles/references 200, long-form text 2000–5000).
 *
 * Shared by CreateAuditFindingSchema / UpdateAuditFindingSchema (backend)
 * and AddFindingModal / EditFindingModal (frontend). Enums (finding_type,
 * severity, resource_type, status), rating bounds and date formats stay
 * server-side; FE Selects constrain them.
 */
export const AUDIT_FINDING_FIELD_RULES = {
  title: { required: true, maxLength: 200 },
  description: { required: true, maxLength: 5000 },
  section: { maxLength: 100 },
  recommendations: { maxLength: 2000 },
  regulatory_reference: { maxLength: 200 },
} satisfies Record<string, ValidationRules>;

export const AUDIT_FINDING_FIELD_LABELS: Record<
  keyof typeof AUDIT_FINDING_FIELD_RULES,
  string
> = {
  title: "Title",
  description: "Description",
  section: "Section",
  recommendations: "Recommendations",
  regulatory_reference: "Regulatory reference",
};
